<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>Artikelsuche</li>
    </ul>
  </div>
  <a class="bm-btn" [routerLink]="['/', 'artikel', 'neu']">
    <i class="fa fa-long-arrow-right"></i><i class="fa fa-building-o"></i>Wareneingang
  </a>
  <a class="bm-btn" href="/warehouse/article/labelTest">Etikettentest</a>
</div>
<div class="page-content page-frame overflow-y-auto">
  <div class="page-sheet w-full max-w-sm mx-auto">
    <div class="bm-card bm-card-sm">
      <form class="bm-card-body" (submit)="search()" [formGroup]="articleSearchForm">
        <div class="bm-card-title">Neue Abfrage</div>
        <fieldset class="bm-fieldset">
          @if (statusList) {
            <label class="bm-fieldset-label">Status</label>
            <ng-select
              [items]="statusList"
              bindLabel="description"
              bindValue="id"
              formControlName="status_id"
              placeholder="Status auswählen"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.description }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
                <div *ngIf="item.description.toLowerCase().includes(searchTerm.toLowerCase())">
                  {{ item.description }}
                </div>
              </ng-template>
            </ng-select>
          }
          <label class="bm-fieldset-label">Produkt</label>
          <ng-select
            [items]="products"
            bindLabel="description"
            bindValue="id"
            formControlName="product_id"
            placeholder="Produkt"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.description }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
              <div *ngIf="item.description.toLowerCase().includes(searchTerm.toLowerCase())">
                {{ item.description }}
              </div>
            </ng-template>
          </ng-select>

          <label class="bm-fieldset-label">SN</label>
          <input class="bm-input" type="text" placeholder="SN" formControlName="serial_number" />

          <label class="bm-fieldset-label">RMA</label>
          <input class="bm-input" type="text" placeholder="RMA" formControlName="rma" />
        </fieldset>

        <button class="bm-btn bm-btn-block bm-btn-primary mt-4">Abfrage starten</button>
      </form>
    </div>
  </div>
</div>
